import type { ProductResult, ScoredProduct } from "./types";

export function productsToCsv(rows: ProductResult[]): string {
  const headers = [
    "title",
    "asin",
    "region",
    "category",
    "sizeClass",
    "affiliateUrl",
    "detailUrl",
    "price",
    "currency",
    "rating",
    "reviewCount",
    "confidenceScore",
    "source",
    "notes"
  ];
  return rowsToCsv(headers, rows as unknown as Record<string, unknown>[]);
}

export function scoredProductsToCsv(rows: ScoredProduct[]): string {
  const headers = [
    "runId",
    "collectedAt",
    "region",
    "categoryPack",
    "seedQuery",
    "title",
    "asin",
    "affiliateUrl",
    "detailUrl",
    "price",
    "currency",
    "rating",
    "reviewCount",
    "imageUrl",
    "source",
    "contentTopicScore",
    "productRecommendScore",
    "recommendationStatus",
    "recommendationReasons",
    "warnings"
  ];
  return rowsToCsv(headers, rows as unknown as Record<string, unknown>[]);
}

function rowsToCsv(headers: string[], rows: Array<Record<string, unknown>>): string {
  const body = rows.map((row) =>
    headers
      .map((header) => {
        const value = row[header];
        if (Array.isArray(value)) {
          return csvCell(value.join(";"));
        }
        return csvCell(String(value ?? ""));
      })
      .join(",")
  );
  return [headers.join(","), ...body].join("\n");
}

function csvCell(value: string): string {
  return `"${value.replaceAll('"', '""')}"`;
}
